// extracted by mini-css-extract-plugin
export default {"SortModel":"sort-model_SortModel__hlNnV","title":"sort-model_title__Vp0gp","SortSection":"sort-model_SortSection__fiDkz","sortTitle":"sort-model_sortTitle__cJebZ"};